"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreOrganizationsAllGetAsyncSlice = void 0;
const name_1 = require("./name.js");
const _api_1 = require("../../../api/index.js");
const xuder_1 = require("@sonar-software/xuder");
exports.coreOrganizationsAllGetAsyncSlice = (0, xuder_1.createGetAsyncSlice)({
    name: name_1.CoreOrganizationsAllName,
    receive: true,
    request: false,
    requestHandler: (request) => (0, _api_1.getAllOrganizations)(request).then((response) => (Object.assign(Object.assign({}, response), { data: response.data ? {
            results: response.data.organizations
        } : undefined }))),
    retainDataOnRequest: true,
    yieldType: xuder_1.SagaYieldType.Latest
});
//# sourceMappingURL=get.js.map